import { BreachType, FormDataType } from 'contexts/FormProvider';
import get from 'lodash/get';
import { formatDate, toNumber, transformedCheckboxValueCategorized } from './utils';
import isEmpty from 'lodash/isEmpty';
import { startCase } from 'lodash';

export function remapBRH(data: FormDataType) {
  const breachType: BreachType = data.breachType as BreachType;
  let dataPrivacy = null;
  if (breachType === 'Data, Privacy, Security') {
    const finalDataPrivacy = transformedCheckboxValueCategorized(data.dataPrivacy);
    if (!isEmpty(data.otherDetails)) {
      finalDataPrivacy.push({
        category: 'Other',
        selected: [data.otherDetails as string],
      });
    }
    dataPrivacy = finalDataPrivacy;
  }

  return {
    your_details: {
      relationship: data.relationship,
      qbe_business: data.qbeBusiness,
      first_name: data.firstName,
      last_name: data.lastName,
      organisation: data.organisation,
      email_address: data.emailAddress,
      phone_number: data.phoneNumber,
    },
    breach_details: {
      breach_type: breachType,
      date_occurred: formatDate(data.occuredDate),
      date_discovered: formatDate(data.discoveredDate),
      breach_description: data.breachDescription,
      data_privacy: dataPrivacy,

      tmd: breachType === 'Dealings Outside of TMD' ? data.tmdDescription : null,
      gicop: breachType === 'GI Code of Practice' ? data.gicopArea : null,
      root_cause: transformedCheckboxValueCategorized(data.rootCause),
      product: data.productType,
      policy_number: data.policyNumber,
      claim_number: breachType !== 'Dealings Outside of TMD' ? data.claimNumber : null,
      customers: startCase(data.customersAffected as string),
      customer_number: data.customersAffected === 'yes' ? data.customerNumber : null,
      financial_loss: data.customersAffected === 'yes' ? startCase(data.financialLoss as string) : null,
      estimated_loss: data.financialLoss === 'yes' ? `$${toNumber(data.estimatedLoss as string, true)}` : null,
    },
    resolution_details: {
      resolved: startCase(data.resolved),
      date_resolved: get(data, 'resolved') === 'yes' ? formatDate(data.resolvedDate) : null,
      resolution_description: get(data, 'resolutionDesc'),
    },
  };
}
